module.exports = __webpack_public_path__ + "static/Retail-Photo1-21b53549674981f80af27f3db845b277.png";